import React from "react";

type SVGProps = React.SVGAttributes<SVGElement>;

export const SolanaLogo: React.FC<SVGProps> = (props) => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={props.style || { padding: 4 }}
    {...props}
  >
    <path
      d="M0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28C56 43.464 43.464 56 28 56C12.536 56 0 43.464 0 28Z"
      fill="#14F195"
      fillOpacity="0.12"
    />
    <g clipPath="url(#clip0_4_47)">
      <path
        d="M16.303 35.3706C16.5186 35.155 16.8151 35.0292 17.1295 35.0292H45.6416C46.1625 35.0292 46.4231 35.658 46.0547 36.0263L40.4224 41.6587C40.2068 41.8743 39.9104 42 39.596 42H11.0839C10.5629 42 10.3024 41.3712 10.6707 41.0029L16.303 35.3706Z"
        fill="#14F195"
      />
      <path
        d="M16.303 14.3414C16.5276 14.1258 16.824 14 17.1295 14H45.6416C46.1625 14 46.4231 14.6288 46.0547 14.9971L40.4224 20.6295C40.2068 20.845 39.9104 20.9708 39.596 20.9708H11.0839C10.5629 20.9708 10.3024 20.342 10.6707 19.9737L16.303 14.3414Z"
        fill="#14F195"
      />
      <path
        d="M40.4224 24.7886C40.2068 24.573 39.9104 24.4472 39.596 24.4472H11.0839C10.5629 24.4472 10.3024 25.076 10.6707 25.4444L16.303 31.0767C16.5186 31.2923 16.8151 31.418 17.1295 31.418H45.6416C46.1625 31.418 46.4231 30.7892 46.0547 30.4209L40.4224 24.7886Z"
        fill="#14F195"
      />
    </g>
    <defs>
      <clipPath id="clip0_4_47">
        <rect
          width="35.875"
          height="28"
          fill="white"
          transform="translate(10.5 14)"
        />
      </clipPath>
    </defs>
  </svg>
);
